import { ToastProvider, useIsBreakpointLargeAndUp } from '@afterpaytouch/core'
import React, { FunctionComponent, ReactNode } from 'react'

import { useConsumerCountry } from '../../state'
import { Header } from '../../component/Header'
import clsx from 'clsx'
import styles from './style.module.css'
import { Footer } from '../../component/Footer'

interface Props {
  children?: ReactNode
  isHideClose?: boolean
  fullscreenWhite?: boolean
}

export const WhiteBgLayout: FunctionComponent<Props> = ({ children, isHideClose, fullscreenWhite }) => {
  const country = useConsumerCountry()
  const isDesktop = useIsBreakpointLargeAndUp()
  const classNames = clsx(styles.container, isDesktop && styles.desktop)
  return (
    <div className={fullscreenWhite ? clsx(styles.light, 'bg-light') : styles.original}>
      <div className={classNames}>
        <ToastProvider>
          <div className='flex h-full flex-col'>
            <div className='flex flex-1 flex-col'>
              <Header country={country} isHideClose={isHideClose} />
              {children}
            </div>
            <div className='bottom-0 -ml-4 flex w-full max-w-md justify-center'>
              <Footer isHelpDisplayed={false} center />
            </div>
          </div>
        </ToastProvider>
      </div>
    </div>
  )
}

// eslint-disable-next-line react/display-name
export const getLayout = (props?: Props) => (page) => <WhiteBgLayout {...props}>{page}</WhiteBgLayout>
